import React from 'react';
import { FaPlane } from 'react-icons/fa';

const PlaneSpinner = () => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center 
                    bg-gradient-to-br from-[#020617] via-[#0B1E34] to-[#132F4C]">

      <style>
        {`
          @keyframes takeOffPlane {
            0% { transform: translate(-140%, 60%) rotate(-20deg) scale(0.8); opacity: 0; }
            20% { opacity: 1; }
            60% { transform: translate(20%, -20%) rotate(-20deg) scale(1.1); opacity: 1; }
            100% { transform: translate(160%, -100%) rotate(-20deg) scale(1); opacity: 0; }
          }

          @keyframes hexGlow {
            0%, 100% { 
              transform: scale(1); 
              box-shadow: 0 0 25px rgba(255, 165, 0, 0.45); 
            }
            50% { 
              transform: scale(1.06); 
              box-shadow: 0 0 45px rgba(255, 165, 0, 0.7); 
            }
          }

          @keyframes trailFade {
            0% { opacity: 0; }
            15% { opacity: 0.6; }
            70% { opacity: 0.3; }
            100% { opacity: 0; }
          }

          .hexagon {
            width: 200px;
            height: 120px;
            background: linear-gradient(135deg, #f97316, #ea580c);
            position: relative;
            clip-path: polygon(
              50% 0%,
              93% 25%,
              93% 75%,
              50% 100%,
              7% 75%,
              7% 25%
            );
            display: flex;
            align-items: center;
            justify-content: center;
            animation: hexGlow 2.5s ease-in-out infinite;
            overflow: hidden;
          }

          .plane {
            color: white;
            font-size: 3.2rem;
            position: absolute;
            animation: takeOffPlane 2.5s ease-in-out infinite;
            z-index: 2;
          }

          .trail {
            position: absolute;
            width: 90px;
            height: 6px;
            background: linear-gradient(to right, rgba(255,255,255,0.9), transparent);
            border-radius: 4px;
            transform: rotate(-20deg);
            animation: trailFade 2.5s ease-in-out infinite;
            z-index: 1;
          }

          .brand-name {
            margin-top: 2rem;
            font-size: 2.4rem;
            font-weight: 800;
            color: #fcd9b6;
            font-family: 'Poppins', sans-serif;
            text-shadow: 0 3px 10px rgba(255,165,0,0.6);
            letter-spacing: 1px;
            text-align: center;
          }

          .loading-text {
            margin-top: 0.2rem;
            font-size: 1.1rem;
            font-weight: 500;
            color: #d1e7ff;
            text-align: center;
            opacity: 0.9;
            font-style: italic;
          }
        `}
      </style>

      <div className="hexagon">
        <div className="trail"></div>
        <FaPlane className="plane" />
      </div>

      <div className="brand-name">BookTrip4Me</div>
      <div className="loading-text">Searching the Best Flight Deals…</div>
    </div>
  );
};

export default PlaneSpinner;
